import axios from 'axios';

export default function getAllEditors() {
  return axios.get('/api/v1/lwadmin/profile/search/editors');
}
